var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['nav-containter']},_vm._l((_vm.tabs),function(x,i){return _c('div',{key:i,class:['nav-item', _vm.nowIndex == i ? 'active' : ''],on:{"click":function($event){return _vm.clickItem(x, i)}}},[_vm._v(" "+_vm._s(x.paramName)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }